export function convertCamelCaseToTitleCase(input: string): string {
  return input
    .replace(/([A-Z])/g, ' $1') // Add a space before each uppercase letter
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
    .trim() // Remove any leading/trailing spaces
}

export function convertKebabCaseToTitleCase(input: string): string {
  return input
    .replace(/-/g, ' ') // Replace hyphens with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()) // Capitalize the first letter of each word
    .trim() // Remove any leading/trailing spaces
}
